<div>
    <div class="top_panel">
        <h3>{{(data.isAddType ? 'Add' : 'Update') + " " + data.dayName}} Time Schedule</h3>
        <span (click)="close()"><mat-icon>close</mat-icon></span>
    </div>
    <div class="formarea">
        <form [formGroup]="timeScheduleForm">
          <div class="inputprt">
            <mat-form-field appearance="outline" fxFlex="auto">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status">
                <mat-option *ngFor="let item of status" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="timeScheduleForm.controls['status'].touched && timeScheduleForm.controls['status'].hasError('required')">This is required field.
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="auto">
              <mat-label>Start Time</mat-label>
              <mat-select formControlName="startTime">
                <mat-option *ngFor="let time of scheduleTimes" [value]="time">
                  {{time}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="timeScheduleForm.controls['startTime'].touched && timeScheduleForm.controls['startTime'].hasError('required')">This is required field.
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="auto">
              <mat-label>End Time</mat-label>
              <mat-select formControlName="endTime">
                  <mat-option *ngFor="let time of scheduleTimes" [value]="time">
                      {{time}}
                  </mat-option>
              </mat-select>
              <mat-error *ngIf="timeScheduleForm.controls['endTime'].touched && timeScheduleForm.controls['endTime'].hasError('required')">This is required field.
              </mat-error>
              <mat-error *ngIf="timeScheduleForm.controls['endTime'].hasError('endTimeError')">
                  End time must be greater than start time.
                </mat-error>
            </mat-form-field>
          </div>
            

              <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
                <button mat-button type="button" class="sub-button" (click)="submit()"><span>{{data.isAddType ? 'Add' : 'Update'}}</span></button>
                <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
            </div>
        </form>
    </div>
</div>
